var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vector-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.s0 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer copy",
    fillRule: "evenodd",
    className: "s0",
    d: "m18.57 6.85l-10.15 9.69c-0.26 0.25-0.6 0.38-0.96 0.38c-0.36 0-0.7-0.14-0.96-0.38l-5.08-4.85c-0.27-0.25-0.42-0.6-0.43-0.97c-0.01-0.37 0.13-0.72 0.38-0.99c0.25-0.27 0.6-0.42 0.97-0.43c0.37-0.01 0.72 0.13 0.99 0.38l4.12 3.93l9.2-8.78c0.27-0.25 0.62-0.39 0.99-0.38c0.37 0.01 0.72 0.16 0.97 0.43c0.25 0.27 0.39 0.62 0.38 0.99c-0.01 0.37-0.16 0.72-0.43 0.97v0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckWhite);
export default __webpack_public_path__ + "static/media/icon_check_white.8fc7dab3f5b4aaa022314d1b1ab63363.svg";
export { ForwardRef as ReactComponent };